var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVada(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 625,
    height: 299,
    viewBox: "0 0 625 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M622.72 132.327L597.628 119.426",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M608.48 140.107V168.764",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M608.48 83.6585V112.316",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M597.509 296.55H622.72V77.2575L597.509 59.8464",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85522 133.666L27.9476 120.765",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0952 140.107V168.764",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0952 83.6585V112.316",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0658 296.55H2.85522V77.2574L28.0658 60.457V296.55Z",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M378.315 129.885H244.857V283.551H378.315V129.885Z",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M386.154 115.251H237.018V129.885H386.154V115.251Z",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M268.039 283.216V203.763C268.039 168.567 311.586 160.196 311.586 160.196C311.586 160.196 355.153 167.169 355.153 203.763V283.216",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M280.743 283.216V211.425C280.743 185.643 311.586 174.83 311.586 174.83C311.586 174.83 342.43 183.555 342.43 211.425V283.216",
    stroke: "#EA4335",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M258.092 142.155V152.121",
    stroke: "#EA4335",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M271.387 142.155V152.121",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M284.662 142.155V152.121",
    stroke: "#EA4335",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M297.957 142.155V152.121",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M311.232 142.155V152.121",
    stroke: "#EA4335",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M324.526 142.155V152.121",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M337.821 142.155V152.121",
    stroke: "#EA4335",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M351.096 142.155V152.121",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M364.391 142.155V152.121",
    stroke: "#EA4335",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M228.49 101.306H397.834",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M380.423 76.8636H241.725V89.1143H380.423V76.8636Z",
    stroke: "#EA4335",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M327.087 45.4686C327.087 37.0585 312.256 36.507 312.256 31.1891H311.98C311.98 36.507 297.13 37.0979 297.13 45.4686C297.131 46.9752 297.522 48.4559 298.263 49.7672C299.005 51.0785 300.073 52.1759 301.364 52.953H298.587V66.1097H325.748V52.953H322.97C324.239 52.1615 325.284 51.0579 326.005 49.7475C326.725 48.4372 327.098 46.964 327.087 45.4686V45.4686Z",
    stroke: "#EA4335",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M279.541 45.4686C279.541 37.0585 264.69 36.507 264.69 31.1891H264.415C264.415 36.507 249.564 37.0979 249.564 45.4686C249.546 46.9829 249.921 48.476 250.653 49.8018C251.385 51.1276 252.448 52.2405 253.74 53.0317H250.963V66.1885H278.143V52.953H275.346C276.629 52.1711 277.69 51.0716 278.424 49.7606C279.159 48.4497 279.544 46.9714 279.541 45.4686V45.4686Z",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M374.652 45.4686C374.652 37.0585 359.821 36.507 359.821 31.1891H359.525C359.525 36.507 344.694 37.0979 344.694 45.4686C344.676 46.9829 345.051 48.476 345.783 49.8018C346.515 51.1276 347.579 52.2405 348.87 53.0317H346.093V66.1885H373.253V52.953H370.476C371.756 52.1687 372.812 51.0682 373.544 49.7573C374.275 48.4465 374.657 46.9696 374.652 45.4686Z",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M391.118 2H233.099L194.16 8.9723V22.2078H430.076V8.9723L391.118 2Z",
    stroke: "#EA4335",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M130.168 96.0866V74.4212C130.168 65.9521 114.845 59.0782 114.845 59.0782C114.845 59.0782 99.5022 65.9521 99.5022 74.4212V96.0866",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3383 106.19H150.042",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M114.491 118.028V148.359",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3706 118.028V148.359",
    stroke: "#FBBC04",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M133.32 118.028V148.359",
    stroke: "#FBBC04",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M149.332 45.9018H80.3383V296.55H149.332V45.9018Z",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8423 100.242V78.577C65.8423 70.1079 54.2218 66.4445 54.2218 66.4445C54.2218 66.4445 42.6013 76.509 42.6013 84.9782V106.643",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0659 120.765L80.9097 106.19",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9658 125.473V155.784",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2183 129.254V159.566",
    stroke: "#FBBC04",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2256 121.534V151.845",
    stroke: "#FBBC04",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3778 296.55H28.0659V60.4767L80.3778 46.0397V296.55Z",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M163.868 100.242V78.577C163.868 70.1079 175.489 66.4445 175.489 66.4445C175.489 66.4445 187.109 76.509 187.109 84.9782V106.643",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M201.644 120.765L148.801 106.19",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M175.764 125.473V155.784",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M189.492 129.254V159.566",
    stroke: "#FBBC04",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M161.485 121.534V151.845",
    stroke: "#FBBC04",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M149.333 296.55H201.644V60.4767L149.333 46.0397V296.55Z",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M201.644 60.4767L149.333 46.0397",
    stroke: "#EA4335",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M149.333 296.55H430.588",
    stroke: "#EA4335",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M226.875 132.327L201.782 119.426",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M212.635 140.107V168.764",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M212.635 83.6585V112.316",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M201.644 296.55H226.875V77.2575L201.644 59.8464V296.55Z",
    stroke: "#EA4335",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M213.147 23.6062V67.8626",
    stroke: "#EA4335",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M494.835 96.0866V74.4212C494.835 65.9521 510.178 59.0782 510.178 59.0782C510.178 59.0782 525.502 65.9521 525.502 74.4212V96.0866",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M544.666 106.19H474.982",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M510.513 118.028V148.359",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M528.633 118.028V148.359",
    stroke: "#FBBC04",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M491.704 118.028V148.359",
    stroke: "#FBBC04",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M475.671 296.55H544.666V45.9018H475.671V296.55Z",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M559.733 100.242V78.577C559.733 70.1079 571.354 66.4445 571.354 66.4445C571.354 66.4445 582.974 76.509 582.974 84.9782V106.643",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M597.51 120.765L544.666 106.19",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M571.61 125.473V155.784",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M585.357 129.254V159.566",
    stroke: "#FBBC04",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M557.35 121.534V151.845",
    stroke: "#FBBC04",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M545.198 296.55H597.51V60.4767L545.198 46.0397V296.55Z",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M461.175 100.242V78.577C461.175 70.1079 449.555 66.4445 449.555 66.4445C449.555 66.4445 437.934 76.509 437.934 84.9782V106.643",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M423.399 120.765L476.243 106.19",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M449.299 125.473V155.784",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M435.551 129.254V159.566",
    stroke: "#FBBC04",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M463.558 121.534V151.845",
    stroke: "#FBBC04",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M475.711 296.55H423.399V60.4767L475.711 46.0397",
    stroke: "#EA4335",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M398.188 132.327L423.281 119.426",
    stroke: "#34A853",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M412.428 140.107V168.764",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M412.428 83.6585V112.316",
    stroke: "#4285F4",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M423.399 296.55H398.188V77.2575L423.399 59.8464V296.55Z",
    stroke: "#EA4335",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M411.896 23.6062V67.8626",
    stroke: "#EA4335",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVada);
export default __webpack_public_path__ + "static/media/Vada.b5cfa94a92bbf92556e324068d51a62c.svg";
export { ForwardRef as ReactComponent };